<template>
  <v-dialog
    :model-value="modelValue"
    max-width="500"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <v-card class="notification-dialog">
      <v-card-text class="pa-6">
        <div class="d-flex flex-column align-center mb-6">
          <v-avatar
            size="120"
            class="bg-primary mb-4 elevation-2"
            color="primary"
          >
            <v-icon
              size="64"
              color="grey-lighten-3"
            >
              mdi-bell
            </v-icon>
          </v-avatar>
          <h2 class="text-h5 font-weight-medium mb-1">
            Notifications
          </h2>
          <p class="text-subtitle-1 text-medium-emphasis">
            Stay updated on important events
          </p>
        </div>

        <v-divider class="mb-6" />

        <!-- Empty State -->
        <div class="d-flex flex-column align-center py-8">
          <v-icon
            icon="mdi-bell-sleep"
            size="64"
            color="grey-lighten-1"
            class="mb-4"
          />
          <h3 class="text-h6 text-grey-darken-1 mb-2">
            No New Notifications
          </h3>
          <p class="text-body-1 text-medium-emphasis text-center">
            You're all caught up! Check back later for updates and important announcements.
          </p>
        </div>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="primary"
          variant="text"
          @click="emit('update:modelValue', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
interface Props {
  modelValue: boolean
}

defineProps<Props>()
const emit = defineEmits<{
  'update:modelValue': [value: boolean]
}>()
</script>

<style scoped>
.notification-dialog :deep(.v-card) {
  border-radius: 12px;
}
</style> 